import React from 'react';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel1, HeadingLevel4 } from '@yme/tokens/typography';
export function TitleWithSubTitle({ title, subTitle }) {
    return (React.createElement(FlexWrapper, { gap: "8px", paddingMobile: "0 16px", paddingTablet: "0 24px", paddingDesktop: "0", flexDirection: "column" },
        subTitle && React.createElement(HeadingLevel4, { color: colorCoreBlack300 }, subTitle),
        React.createElement(HeadingLevel1, null, title)));
}
TitleWithSubTitle.displayName = 'TitleWithSubTitle_AEMComponent';
